module.exports = __webpack_public_path__ + "static/media/RegularFitMenBeigeCottonLycraBlendtrousers.e24bdb81.jpeg";